<sbf-error-shell [errorNumber]="400" message1="YOUR CLIENT HAS ISSUED A MALFORMED OR ILLEGAL REQUEST" message2="KEEP EXPLORING"></sbf-error-shell>
